import { getHubAuthHeaders } from "@helpers/lib/hub-auth";
import { fetch as expoFetch } from "expo/fetch";

import { pumpSSEStream } from "./parseUIMessageStream";

/**
 * POST JSON to a ProEthics endpoint with hub auth, then drain the SSE response,
 * handing each chunk to `feed`. Shared by the turn + summative calls; callers
 * own their own error handling.
 */
export const streamProethicsPost = async (
	url: string,
	body: unknown,
	feed: (chunk: Uint8Array) => void,
) => {
	const res = await expoFetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			...(await getHubAuthHeaders()),
		},
		body: JSON.stringify(body),
	});
	await pumpSSEStream(res.body, feed);
};
